import { YouTubeVideoPlayer } from '@/components/ProductDetailComponents';
import Empty from '@/components/Search/Empty';
import Image from '@/components/UI/Image';
import generatorPlayUrl from '@/utils/generatorPlayUrl';
import { useGlobal } from '@/utils/useGlobal';
import { memo } from 'react';
import css from './index.module.scss';
const getMediaVideoMap = (locale: string) => {
    switch (locale) {
        case 'de':
            return [
                {
                    downloadInfoId: '1551521109109354497',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'de_DE',
                    title: 'Ecoflow Power Kits - ist das die Revolution für Strom im Wohnmobil? ',
                    fileUrl: 'https://www.youtube.com/watch?v=HKJZqr4hd4Q',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '629',
                },
            ];

        case 'fr':
            return [
                {
                    downloadInfoId: '1551521108937388033',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: '24H DANS UN CAMPING-CAR DE LUXE VS UNE CARAVANE PAS OUF',
                    fileUrl: 'https://www.youtube.com/watch?v=0py8BvdfG6E',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '620',
                },
                {
                    downloadInfoId: '1551521108983525378',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: 'Revolution electrique en Camping-car ou Habitat alternatif',
                    fileUrl: 'https://www.youtube.com/watch?v=IjiHaQ2LisA',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '621',
                },
                {
                    downloadInfoId: '1551521108996108290',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: 'ECOFLOW POWER KIT installé dans mon CAMPING-CAR',
                    fileUrl: 'https://www.youtube.com/watch?v=-l9bRK0jO0Q',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '622',
                },
                {
                    downloadInfoId: '1551521109004496898',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: 'JE REFUSE UNE BATTERIE ECOFLOW À PLUSIEURS MILLIERS D’EURO #battery #solar #vanlife',
                    fileUrl: 'https://www.youtube.com/watch?v=yVz1yzzhed4',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '623',
                },
                {
                    downloadInfoId: '1551521109012885505',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: 'On a trouvé une véritable alternative au powerwall Tesla',
                    fileUrl: 'https://www.youtube.com/watch?v=_FpNZ5N_WXE',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '624',
                },
                {
                    downloadInfoId: '1551521109025468418',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: "Live de Pré-présentation du kit énergie d'Ecoflow - En direct d'Allemagne 🇩🇪",
                    fileUrl: 'https://www.youtube.com/watch?v=8xMgt0-ry2w',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '625',
                },
                {
                    downloadInfoId: '1551521109038051330',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: 'Présentation ECOFLOW power kit',
                    fileUrl: 'https://www.youtube.com/watch?v=nu0mjerqnU0',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '626',
                },
                {
                    downloadInfoId: '1551521109046439938',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: 'INNOVATION 🔋 SOLAIRE 2022 être autonome en véhicules aménagé @Ecoflow Power Kits (+ code promo)',
                    fileUrl: 'https://www.youtube.com/watch?v=mDpfOWehZyE',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '627',
                },
                {
                    downloadInfoId: '1551521109059022849',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'fr_FR',
                    title: "Exclu: Ecoflow Power Kit energie, Nous étions à l'avant-première ! Ce truc est l'avenir du Solaire !",
                    fileUrl: 'https://www.youtube.com/watch?v=mmK6Tn6K0Ag',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '628',
                },
            ];

        default:
            return [
                {
                    downloadInfoId: '1550040573329043458',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'en_US',
                    title: 'Easy Solar Power for Off Grid Living Tiny Home, VAN Life, RV - EcoFlow Power Kit Full Review',
                    fileUrl: 'https://www.youtube.com/watch?v=vxiudEZfT2g',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-21 16:50:46',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '272',
                },
                {
                    downloadInfoId: '1550040573329043458',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'en_US',
                    title: 'PLUG & PLAY SOLAR FOR OFF-GRID & VANLIFE - ECOFLOW Modular POWER KIT REVIEW',
                    fileUrl: 'https://www.youtube.com/watch?v=ZN2H_I37RUg',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-21 16:50:46',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '272',
                },
                {
                    downloadInfoId: '1550040573345820674',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'en_US',
                    title: 'Beginner Friendly DIY Solar Power System  for Van or Home - Wranglerstar Professional Homeowner',
                    fileUrl: 'https://www.youtube.com/watch?v=OSxk2E9Hcls',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-21 16:50:46',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '273',
                },
                {
                    downloadInfoId: '1550040573354209282',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'en_US',
                    title: 'EASIEST Off Grid Solar Power... just like a little Lego',
                    fileUrl: 'https://www.youtube.com/watch?v=OO23RTRIVGU',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-21 16:50:46',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '274',
                },
                {
                    downloadInfoId: '1551521109067411457',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'en_US',
                    title: 'EcoFlow Power Kits | Geeky UK Review',
                    fileUrl: 'https://www.youtube.com/watch?v=q_D_5fBXdg8',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '275',
                },
                {
                    downloadInfoId: '1551521109084188674',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'en_US',
                    title: 'Vanlifers In Germany (What Really Happened)',
                    fileUrl: 'https://www.youtube.com/watch?v=VAvNyoK75Aw',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '276',
                },
                {
                    downloadInfoId: '1551521109092577281',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'en_US',
                    title: 'The New EcoFlow Power Kit Launch at Essen, Germany 🇩🇪',
                    fileUrl: 'https://www.youtube.com/watch?v=Nir6Kkyxkxw',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '277',
                },
                {
                    downloadInfoId: '1551521109100965889',
                    downloadInfoBaseId: '1249887255751163904',
                    lang: 'en_US',
                    title: 'Van Life & Off Grid POWER will NEVER BE THE SAME!',
                    fileUrl: 'https://www.youtube.com/watch?v=Y92cWam3h_U',
                    classify: 'VIDEO_COURSE',
                    sort: 0,
                    createTime: '2022-07-25 18:53:53',
                    updateTime: '2022-08-12 02:20:27',
                    efcmsDownloadInfoForWebId: '278',
                },
            ];
    }
};

function Child() {
    const { useState, useLang, gtm, useRouter } = useGlobal();
    const router = useRouter();
    const { locale } = router;
    const { t } = useLang('ecoflowpowerkitsseries');
    const videoList = getMediaVideoMap(locale);
    const [curVideo, setCurVideo] = useState({ url: '', isShow: false } as any);

    const handlePlayVideo = (video: any, index: number) => {
        const { isYouTubeVideo, url } = generatorPlayUrl(video.fileUrl);
        gtm.push({
            event: 'uaEvent',
            event_name: 'video',
            title_name: video.title,
            position: `Pre-Order_${index + 1}`,
        });

        if (isYouTubeVideo) {
            setCurVideo({ url, isShow: isYouTubeVideo });
        } else {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.click();
        }
    };

    return (
        <div className={`media ${css.media}`}>
            <div className="video-content">
                <ul className="air-media-video-box">
                    {videoList?.map((videoItem: any, index: number) => (
                        <li className="air-media-video-item" key={videoItem.downloadInfoId + index}>
                            <div className="air-media-video-mainImg" onClick={() => handlePlayVideo(videoItem, index)}>
                                <Image
                                    src={generatorPlayUrl(videoItem.fileUrl)?.imageUrl || '/img/search/error.png'}
                                    layout="fill"
                                    alt={videoItem?.title}
                                    aria-label={videoItem?.title}
                                />
                                <div className="air-media-video-cover"></div>
                                <div className="air-media-play">
                                    <Image
                                        src="/icons/play-support.svg"
                                        layout="fill"
                                        alt={t('presale.media.play_icon')}
                                        aria-label={t('presale.media.play_icon')}
                                    />
                                </div>
                            </div>
                            <p data-url={videoItem.fileUrl} className="air-media-video-title">
                                {videoItem.title}
                            </p>
                        </li>
                    ))}
                    {/* 无数据 */}
                    {!videoList?.length && <Empty isMobile={true} />}
                </ul>
            </div>
            <YouTubeVideoPlayer
                floatVideo={curVideo.isShow}
                setFloatVideo={() => setCurVideo({ url: '', isShow: false })}
                videoSrc={`${curVideo.url}?autoplay=1`}
            />
        </div>
    );
}

const ChildMemo = memo(Child);

export default function Media({ newsList }: any) {
    return <ChildMemo />;
}
